/** Remove a domain here when delivery is healthy again. Exact matches only. */
export const EMAIL_DELIVERY_ISSUE_DOMAINS: readonly string[] = [];

export function emailDeliveryIssueDomain(email: string): string | undefined {
  const match = /^[^\s@]+@([^\s@]+)$/.exec(email.trim().toLowerCase());
  const domain = match?.[1];
  return domain && EMAIL_DELIVERY_ISSUE_DOMAINS.includes(domain) ? domain : undefined;
}
